exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".card .card-header #buttons {\n  padding: 8px;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/gcp-applications/monash-online-credit/monash-online-credit-prod@2/src/main/client/app/shared/application/outcome-comment/application-outcome-comment.less","/var/lib/jenkins/workspace/gcp-applications/monash-online-credit/monash-online-credit-prod@2/application-outcome-comment.less"],"names":[],"mappings":"AAAA;EAGM,aAAA;CCDL","file":"application-outcome-comment.less","sourcesContent":[".card {\n  .card-header {\n    #buttons {\n      padding: 8px;\n    }\n  }\n}\n\n",".card .card-header #buttons {\n  padding: 8px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"importLoaders":1}!./node_modules/postcss-loader/lib?{"sourceMap":true,"plugins":[null]}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/main/client/app/shared/application/outcome-comment/application-outcome-comment.less
// module id = 368
// module chunks = 0